import { Cookies } from 'react-cookie';

import { FeromonTrapApiResponse } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getFeromonTraps = async (slug: string, page: number, search?: string, ordering?: string) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/object/feromon_traps/${slug}`, {
    headers: {
      Authorization: token,
    },
    params: {
      page,
      search,
      ordering,
    },
  });
  return data.data as FeromonTrapApiResponse;
};
